module.exports = __webpack_public_path__ + "img/lecture-min.a9cdb778.png";